import React from 'react';
import StarIcon8Point from './StarIcon8Point';

const FooterNav = ({ onNavigate, currentPage }) => {
  const getLinks = () => {
    switch (currentPage) {
      case 'services':
        return {
          leftLabel: 'AGENCY',
          leftPage: 'about',
          rightLabel: 'CONNECT',
          rightPage: 'connect'
        };
      case 'about':
        return {
          leftLabel: 'SERVICES',
          leftPage: 'services',
          rightLabel: 'CONNECT',
          rightPage: 'connect'
        };
      case 'connect':
        return {
          leftLabel: 'SERVICES',
          leftPage: 'services',
          rightLabel: 'AGENCY',
          rightPage: 'about'
        };
      case 'navigation':
      case 'hero':
      default:
        return {
          leftLabel: 'SERVICES',
          leftPage: 'services',
          rightLabel: 'CONNECT',
          rightPage: 'connect'
        };
    }
  };

  const { leftLabel, leftPage, rightLabel, rightPage } = getLinks();

  return (
    <div className="footer-nav">
      <a 
        className="nav-link" 
        href={`#${leftPage}`}
        onClick={(e) => {
          e.preventDefault();
          onNavigate(leftPage);
        }}
      >
        {leftLabel}
      </a>
      <StarIcon8Point onClick={onNavigate} dataPage="navigation" />
      <a 
        className="nav-link" 
        href={`#${rightPage}`}
        onClick={(e) => {
          e.preventDefault();
          onNavigate(rightPage);
        }}
      >
        {rightLabel}
      </a>
    </div>
  );
};

export default FooterNav;
